import React, { FC } from 'react'

import styled from 'styled-components'

import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import SuccessIcon from 'src/Assets/Svg/pages-icons/Success.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CrossSellSuccessBlock } from 'src/Components/CrossSellSuccessPopup'
import {
  CrossSellPlatform,
  getCrossSellIntroMessage,
} from 'src/Components/CrossSellSuccessPopup/helpers'

import { FullScreenModal } from '../FullScreenModal'
import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'
import { useSuccessPage } from '../SuccessPage/useSuccessPage'
import { PaymentStateScreen } from '../SuccessPage/PaymentStateScreen'

interface Props {
  startDate?: string | Date
  platformName: CampaignPlatformTypeEnum
}

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 820px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 358px;
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 40px 16px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 600px;
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`
const Bold = styled.span`
  font-weight: 600;
`

const StyledSuccessIcon = styled(SuccessIcon)`
  color: ${({ theme }) => theme.color.brandGreen};
`

export const ScheduleSuccessPage: FC<Props> = ({ startDate, platformName }) => {
  const {
    isLoading,
    isTimedOut,
    isFailed,
    isRetrying,
    isSuccessPageVisible,
    isBonusActive,
    bonusAmount,
    title,
    text,
    onlyDate,
    onCampaignsButtonClick,
    onBalanceButtonClick,
    onTryAnotherMethodClick,
  } = useSuccessPage({ startDate, platformName })

  if (!isSuccessPageVisible) {
    return null
  }

  if (isLoading || isTimedOut || isFailed) {
    return (
      <PaymentStateScreen
        title={title}
        text={text}
        isLoading={isLoading}
        isFailed={isFailed}
        isRetrying={isRetrying}
        onCampaignsButtonClick={onCampaignsButtonClick}
        onBalanceButtonClick={onBalanceButtonClick}
        onTryAnotherMethodClick={onTryAnotherMethodClick}
      />
    )
  }

  const crossSellPlatform = platformName as CrossSellPlatform

  return (
    <FullScreenModal open>
      <Wrapper>
        <Container>
          <StyledSuccessIcon width={40} height={40} />
          <TextContainer>
            <Title>{title}</Title>
            <Text>
              Your track starts its journey on <Bold>{onlyDate}</Bold>
            </Text>
            <Text>{getCrossSellIntroMessage(crossSellPlatform)}</Text>
          </TextContainer>

          <CrossSellSuccessBlock
            currentPlatform={crossSellPlatform}
            isBonusActive={isBonusActive}
            bonusAmount={bonusAmount}
          />

          <PrimaryDottedButton onClick={onCampaignsButtonClick}>
            Back to Campaigns
          </PrimaryDottedButton>
        </Container>
      </Wrapper>
    </FullScreenModal>
  )
}
